import React, { Component, PropsWithChildren } from 'react';
import { FilterContext } from './FilterContext';
import { IFilterItemProps, IFilterValues } from './types';

export class FilterItem extends Component<PropsWithChildren<IFilterItemProps>, {}> {
  public render() {
    return (
      <FilterContext.Consumer>
        {({ batchUpdate, handleChange, values }) => {
          const value = values[this.props.name] || '';
          const filtersCopy: IFilterValues = Object.assign({}, values);

          return this.props.render({
            batchUpdate,
            filterValues: filtersCopy,
            handleChange,
            value,
          });
        }}
      </FilterContext.Consumer>
    );
  }
}

export default FilterItem;
